import Swiper from 'swiper';

export default class Index {
    constructor() {

    }

    init() {
        
    }

    index() {
        this.initCarousel();
    }

    finalize() {
        
    }

    initCarousel() {
        const autoplay = 5000;
        this.carousel =  new Swiper('#mainCarousel', {
            init: true,
            spaceBetween: 10,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            watchSlidesProgress: true,
            autoplay: {
                delay: autoplay,
                disableOnInteraction: true
            }/*,
            on: {
                progress: () => {
                    var elem = document.getElementById("mcprogress"); 
                    var width = 1;
                    var autoplayTime = autoplay / 100;
                    var id = setInterval(frame, autoplayTime);
                    function frame() {
                        if (width >= 100) {
                            clearInterval(id);
                        } else {
                            width++; 
                            elem.style.width = width + '%'; 
                        }
                    }
                }
            }*/
        });

        /*document.getElementById("mainCarousel").onmouseover = () => { 
            this.carousel.autoplay.stop();
        }

        document.getElementById("mainCarousel").onmouseout = () => { 
            this.carousel.autoplay.start();
        }*/
    }
}